import { createSignal, onMount, onCleanup, Show } from "solid-js";
import { SolidQR } from "solid-qr";
import { View, Text } from "@lightningtv/solid";

const QrCode = (props) => {
  const URL = `https://orbixplay.com/mylist/?client_reference_id=${props.deviceID}`;
  const [qrDataUrl, setQrDataUrl] = createSignal("");
  const [supportsBlob, setSupportsBlob] = createSignal(false);
  const [isProcessing, setIsProcessing] = createSignal(false);
  let qrImgRef;
  let intervalRef;

  // Check if URL.createObjectURL is supported (newer LG TVs)
  const checkBlobSupport = () => {
    try {
      return typeof window !== 'undefined' &&
        typeof window.URL !== 'undefined' &&
        typeof window.URL.createObjectURL === 'function';
    } catch (error) {
      return false;
    }
  };

  onMount(() => {
    // Prevent multiple processing
    if (isProcessing()) return;
    setIsProcessing(true);

    // Check blob support on mount
    setSupportsBlob(checkBlobSupport());

    // Wait until QR image is rendered
    intervalRef = setInterval(() => {
      if (qrImgRef?.src?.startsWith("data:image")) {
        const base64 = qrImgRef.src;

        if (supportsBlob()) {
          // Newer LG TVs: Use blob URL if supported
          const url = base64ToBlobUrl(base64);
          setQrDataUrl(url);
        } else {
          // Older WebOS TVs: Use data URL directly
          setQrDataUrl(base64);
        }

        clearInterval(intervalRef);
        intervalRef = null;
        setIsProcessing(false);
      }
    }, 100);

    // Safety cleanup after 10 seconds
    setTimeout(() => {
      if (intervalRef) {
        clearInterval(intervalRef);
        intervalRef = null;
        setIsProcessing(false);
      }
    }, 10000);
  });

  // Cleanup interval on unmount
  onCleanup(() => {
    if (intervalRef) {
      clearInterval(intervalRef);
      intervalRef = null;
    }
    setIsProcessing(false);
  });

  // Safe blob URL creation with fallback for newer TVs
  function base64ToBlobUrl(base64) {
    if (!supportsBlob()) {
      // Older WebOS TVs: Return the data URL directly
      return base64;
    }

    try {
      const parts = base64.split(",");
      const byteString = atob(parts[1]);
      const mimeString = parts[0].split(":")[1].split(";")[0];

      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: mimeString });
      return window.URL.createObjectURL(blob);
    } catch (error) {
      console.error("Error creating blob URL, falling back to data URL:", error);
      // Fallback to data URL for older TVs
      return base64;
    }
  }

  return (
    <View width={390} height={350} x={0} y={-5}>
      {/* Render SolidQR invisibly just to extract the base64 - only once */}
      <Show when={!qrDataUrl() && !isProcessing()}>
        <div style={{ display: "none" }}>
          <SolidQR
            ref={qrImgRef}
            options={{
              type: "image/png",
              color: {
                dark: `#000000FF`,
                light: "#0000000"
              }
            }}
            text={URL}
          />
        </div>
      </Show>

      {/* Show QR code when available, fallback when not */}
      <Show
        when={qrDataUrl()}
        fallback={
          <View width={360} height={340} x={30} y={20}>
            <Text style={{ fontSize: 20, color: "#ffffff" }}>
              Loading QR Code...
            </Text>
          </View>
        }
      >
        <View width={360} height={340} x={10} y={0}>
          <img
            src={qrDataUrl()}
            alt="QR Code"
            style={{ width: "300px", height: "300px" }}
          />
        </View>
      </Show>
    </View>
  );
};

export default QrCode;